/**
 * Parse an ISO string from the backend as UTC.
 *
 * Why this exists: MongoDB strips tz info from `datetime.now(timezone.utc)` and
 * stores it as a naive UTC datetime. FastAPI's default JSON encoder then emits
 * a string like `"2026-05-07T12:00:00.123456"` (no `Z`). The browser's
 * `new Date(str)` parses an ISO 8601 string **without** an offset as **local
 * time**, which makes log timestamps appear shifted by the user's timezone
 * offset (e.g., 5h30m off in IST).
 *
 * This helper appends `Z` if the string lacks a tz designator so the resulting
 * Date is the correct UTC instant; `.toLocaleString()` will then render it in
 * the viewer's local timezone correctly.
 */
export function parseServerDate(iso) {
  if (!iso) return null;
  if (iso instanceof Date) return iso;
  // Already has Z, +HH:MM, +HHMM, -HH:MM, or -HHMM at the end
  const hasTz = /[Zz]$|[+-]\d{2}:?\d{2}$/.test(iso);
  return new Date(hasTz ? iso : `${iso}Z`);
}

/** Full date+time formatter for admin log tables (en-IN). */
export function fmtServerDateTime(iso, opts) {
  const d = parseServerDate(iso);
  if (!d || Number.isNaN(d.getTime())) return iso || '';
  return d.toLocaleString('en-IN', opts || {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
}
